module.exports = "https://static.moomoo.com/components/common-trade-idea-main/images/icon5.42f29c8680.png";